import { CHOOSE_SYNC_CONSTANTS } from "../constants/choose-sync"
import type { SyncDirection } from "../types/choose-sync"

export const isOptionDisabled = (sourceObject: string): boolean => {
  return !CHOOSE_SYNC_CONSTANTS.ENABLED_OBJECTS.includes(sourceObject.toLowerCase())
}

export const getSyncTypeLabel = (direction: SyncDirection): string => {
  return direction === "bidirectional"
    ? CHOOSE_SYNC_CONSTANTS.SYNC_TYPES.BIDIRECTIONAL
    : CHOOSE_SYNC_CONSTANTS.SYNC_TYPES.ONE_WAY
}

export const getCardClassName = (isSelected: boolean, isDisabled: boolean): string => {
  const baseClass = "sync-option-card"
  const modifiers = []

  if (isSelected) modifiers.push("selected")
  if (isDisabled) modifiers.push("disabled")

  return modifiers.length > 0 ? `${baseClass} ${modifiers.join(" ")}` : baseClass
}

export const getAriaLabel = (optionName: string, isDisabled: boolean): string => {
  return isDisabled ? `${optionName} (Currently unavailable)` : `Select ${optionName}`
}
